<template>
    <div class="text-textColor">
        <transition name="fade">
            <div v-if="showrenewLicence" class="bg-black fixed bg-opacity-70 inset-0 z-50 h-screen w-full">
                <form @submit.prevent="create" class="fixed center-h-v bg-white rounded-md shadow-2xl sm:w-1/2 w-full">
                    <transition name="fade">
                        <div v-if="loading" class="inset-0 absolute bg-black rounded-md bg-opacity-10 w-full">
                            <loader class="center-h-v" />
                        </div>
                    </transition>
                    <div class="flex justify-between items-center border-b-1.5 p-3">
                        <p class="text-base">Renew Licence Key</p>
                        <img class="h-6 object-contain cursor-pointer hover:shadow-lg bg-primary rounded-md"
                            src="@/assets/icons/cross-white.png" @click="close()" />
                    </div>
                    <transition name="fade">
                        <div v-if="create_error" class="p-1 text-center text-sm w-full bg-yellow-200">
                            {{ create_error }}
                        </div>
                    </transition>

                    <transition name="fade">
                        <div v-if="showSuccess" class="p-1 text-center text-sm w-full bg-green-200">
                            {{ success_msg }}
                        </div>
                    </transition>

                    <div class="grid grid-cols-2 p-4 gap-3">

                        <div class="text-sm col-span-2">
                            <label class="block pb-1">Organization Name</label>
                            <select name="" id="" class="p-2 bg-gray-200 rounded-full w-full"
                                @change="(e, d) => getOrganization(e)">
                                <option value="" disabled selected>Click to select organization</option>
                                <option :value="organization.Id" v-for="organization of organizations"
                                    :key="organization.Id">
                                    {{ organization.Name }}
                                </option>

                            </select>
                        </div>



                        <div class="text-sm" v-if="selectedOrganization">
                            <label class="block pb-1">Employees</label>
                            <input :value="selectedOrganization.TotalNormalEmployees" type="number"
                                name="TotalNormalEmployees" class="p-2 bg-gray-200 rounded-full w-full"
                                placeholder="Number of Employees" @input="(e) => handleChange(e)" disabled />
                        </div>

                        <div class="text-sm" v-if="selectedOrganization">
                            <label class="block pb-1">Managers</label>
                            <input :value="selectedOrganization.TotalManagers" type="number" name="TotalManagers"
                                class="p-2 bg-gray-200 rounded-full w-full" placeholder="Number of Managers"
                                @input="(e) => handleChange(e)" disabled />
                        </div>


                        <div class="text-sm" v-if="selectedOrganization">
                            <label class="block pb-1">Payment Term</label>
                            <input :value="selectedOrganization?.PaymentTerms.Name" type="text" name="PaymentTerm"
                                class="p-2 bg-gray-200 rounded-full w-full" placeholder="Expiry Date" required
                                @input="(e) => handleChange(e)" disabled />
                        </div>

                        <div class="text-sm" v-if="selectedOrganization">
                            <label class="block pb-1">Expected Expiry Date</label>
                            <input :value="getPeriodInMonths(selectedOrganization?.PaymentTerms.NumberOfMonths)" type="text"
                                name="LicenseEndDate" class="p-2 bg-gray-200 rounded-full w-full" placeholder="Expiry Date"
                                required @input="(e) => handleChange(e)" disabled />
                        </div>

                    </div>
                    <div class="flex justify-end p-5" v-if="selectedOrganization">
                        <button type="submit" class="bg-primary rounded-full px-10 text-sm text-white py-2">
                            Renew
                        </button>
                    </div>
                </form>
            </div>
        </transition>
    </div>
</template>
  
<script>
import { mapGetters } from "vuex";
import Loader from "@/components/loader/loader.vue";
import axios from 'axios'

export default {
    name: "RenewLicenceKey",
    props: ["showrenewLicence", "isRenewalSubmited", 'organizations', "reload"],
    components: { Loader },
    data() {
        return {
            create_error: null,
            loading: false,
            inputDisabled: true,
            currentDate: null,
            showSuccess: false,
            success_msg: null,
            selectedOrganization: null,
            info: {
                Id: null,
                TotalNormalEmployees: null,
                TotalManagers: null,
                LicenseEndDate: null,
            },
        };
    },
    computed: {
        ...mapGetters(["getToken"]),


    },
    created() {
        //console.log(this.organizations?.PaymentTermId, this.organizations?.PaymentTerm)
        //console.log(this.selectedOrganization)
    },
    methods: {
        close() {
            this.$emit("close");
            this.selectedOrganization = null
        },

        getPeriodInMonths(monthsToAdd) {

            // Get the current date
            const currentDate = new Date();

            // Add the specified number of months to the current date
            currentDate.setMonth(currentDate.getMonth() + monthsToAdd);

            // Format the future date as a string in the format YYYY-MM-DD
            const futureDate = currentDate.toISOString().slice(0, 10);
            return futureDate
        },

        formatDate(date) {
            return new Date(date).toISOString().substring(0, 10);
        },
        getOrganization(event) {
            const selectedId = event.target.value;
            this.selectedOrganization = this.organizations.find(organization => organization.Id === selectedId)
            //console.log(this.selectedOrganization)
            this.info = {
                Id: selectedId,
                TotalNormalEmployees: this.selectedOrganization.TotalNormalEmployees,
                TotalManagers: this.selectedOrganization.TotalManagers,
                LicenseEndDate: this.selectedOrganization.LicenseEndDate,
            }

        },


        handleChange(e) {
            const { value, name } = e.target;
            this.info[name] = value
        },
        create() {
            this.loading = true;
            this.info.Id = this.selectedOrganization.Id;

            this.loading = false;
            const options = {
                headers: {
                    Authorization: `Bearer ${this.getToken}`,
                },
            };
            const data = {
                "OrganizationId": this.info.Id,
                // "ExpiryDate": this.info.LicenseEndDate,
                // "Managers": this.info.TotalManagers,
                // "Employees": this.info.TotalNormalEmployees
            }
            //console.log(data);
            axios
                .post(
                    `/licenses/${this.$ApiVersion}/renew`, data,
                    options
                )
                .then(
                    (response) => {

                        if (response.data.StatusCode == 200) {
                            this.loading = false;
                            this.success_msg = response.data.StatusMessage;
                            this.showSuccess = true;
                            this.isRenewalSubmited = true;
                            this.reload();
                            setTimeout(() => {
                                this.showSuccess = false;
                                this.close();
                            }, 1000);
                        }
                    },
                    (error) => {
                        this.create_error = error;
                        this.loading = false;
                        setTimeout(() => {
                            this.create_error = null;
                            this.close();
                        }, 1000);
                    }
                );
        }

    }

};
</script>
  
<style scoped>
.center-h-v {
    position: absolute;
    top: 50%;
    left: 50%;
    -ms-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
}
</style>
  